import { ACTIONS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface MarketingReducer {
    campaigns: any[] | null;
    audienceLists: any[] | null;
    masterTags: any[] | null;
}

const initialState: MarketingReducer = {
    campaigns: null,
    audienceLists: null,
    masterTags: null,
};

const marketingReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.MARKETING_CAMPAIGN.SEARCH:
            return {
                ...state,
                campaigns: action.payload,
            };
        case ACTIONS.MARKETING_AUDIENCE_LIST.SEARCH:
            return {
                ...state,
                audienceLists: action.payload,
            };
        case ACTIONS.MARKETING.MASTER_TAGS:
            return {
                ...state,
                masterTags: action.payload,
            };
        default:
            return state;
    }
};

export default marketingReducer;
